import { render, staticRenderFns } from "./orederRecovery.vue?vue&type=template&id=82a0f602&scoped=true&"
import script from "./orederRecovery.vue?vue&type=script&lang=js&"
export * from "./orederRecovery.vue?vue&type=script&lang=js&"
import style0 from "./orederRecovery.vue?vue&type=style&index=0&id=82a0f602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0f602",
  null
  
)

export default component.exports